import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';

const Hero = ({ onGetQuote, onWhatsApp }) => {
  return (

    <section className="hero-modern" id="home">

<link rel="canonical" href="https://mavrexx.com/" />
      <div className="hero-modern-container">
        <div className="hero-modern-content">
          <div className="hero-label">Industrial 3D Printing </div>
          <h1 className="hero-modern-title">
            Industrial 3D Printing
            <span className="hero-accent">& Reverse Engineering Services in </span>
            Vadodara
          </h1>
          <p className="hero-modern-subtitle">
            From concept validation to production-ready components. We deliver advanced 3D printing, reverse engineering, and precision manufacturing for engineers, startups, and industrial partners.
          </p>
          <div className="hero-modern-cta">
            <Button 
              className="primary-cta large-cta" 
              onClick={onGetQuote}
            >
              Get a Quote
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              className="secondary-cta large-cta" 
              variant="outline"
              onClick={onWhatsApp}
            >
              <MessageCircle className="mr-2 h-5 w-5" />
              Chat on WhatsApp
            </Button>
          </div>
        </div>
        <div className="hero-modern-image">
          <div className="hero-modern-image-wrapper">
            <img 
              src="https://images.unsplash.com/photo-1738305992246-1c7fcdb80f38?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Industrial 3D Printing"
              className="hero-modern-img"
            />
            <div className="hero-modern-overlay"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
